"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const defaultChatStorage_1 = __importDefault(require("./defaultChatStorage"));
const asyncIterate_1 = __importDefault(require("../../BusinessLogicLayer/asyncIterate"));
const NAME = "coach_chat_initializer";
class CoachChatInitializer {
    constructor(cache, userRepository, chatModel, customerRepository) {
        this.isInitialized = null;
        this.initializePromise = null;
        this.ensureInitialized = async () => {
            if (this.isInitialized === null) {
                this.isInitialized =
                    (await this.cache
                        .getNumber(NAME)
                        .withDefault(0)
                        .asPromise()) === 1;
            }
            if (this.isInitialized) {
                return;
            }
            if (this.initializePromise === null) {
                this.initializePromise = this.initializer();
            }
            return await this.initializePromise;
        };
        this.initialize = async () => {
            await (0, asyncIterate_1.default)(await this.userRepository.all(), async (coachUser) => (0, asyncIterate_1.default)(await this.customerRepository.getCustomers(), async (customer) => {
                if (customer.id === "0") {
                    await this.chatModel.setMessages(coachUser.id, customer.id, []);
                    return;
                }
                await this.chatModel.setMessages(coachUser.id, customer.id, (0, defaultChatStorage_1.default)(customer.id, coachUser.id));
            }));
        };
        this.initializer = async () => {
            await this.initialize();
            await this.cache.setNumber(NAME, 1).asPromise();
            this.isInitialized = true;
        };
        this.cache = cache;
        this.chatModel = chatModel;
        this.userRepository = userRepository;
        this.customerRepository = customerRepository;
    }
}
exports.default = CoachChatInitializer;
//# sourceMappingURL=CoachChatInitializer.js.map